import { Currency } from '@/core/currency/interfaces';

const KZT: Currency = {
    name: 'Kazakhstani Tenge',
    demonym: 'Kazakhstani',
    majorSingle: 'Tenge',
    majorPlural: 'Tenge',
    codeNumeric: '398',
    symbol: '₸',
    symbolNative: '₸',
    minorSingle: 'Tıyn',
    minorPlural: 'Tıyn',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'KZT',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default KZT;
